import { Component, input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  imports: [],
  templateUrl: './progress-bar.html',
  styleUrl: './progress-bar.scss'
})
export class ProgressBar {
  percentage = input.required<number>()
  backgroundColor = input('#0E73A9')
  width = input('264px')
  height = input('8px')
  trackColor = input('#E4E7EC')
  borderRadius = input('4px')
}
